import { useQuery } from "@tanstack/react-query";
import { API_PAYMENT, UseAccountResponse } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetAccount = () => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_USE_ACCOUNT],
        queryFn: () => API_PAYMENT.getUseAccount<UseAccountResponse>(),
    });

    return { data, isLoading };
};
